<div class="banner">
    <div class="col-12 pb-5"><h1>My Account</h1></div>
    <div class="tab">
        <ul class="nav nav-tabs">
            <li><a [routerLink]="[{ outlets: { 'my-account-tab': ['account-summary'] } }]" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }">Account Summary</a></li>
            <li><a [routerLink]="[{ outlets: { 'my-account-tab': ['edit-account'] } }]" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }">Edit Account</a></li>
            <li><a [routerLink]="[{ outlets: { 'my-account-tab': ['my-profile'] } }]" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }">My Profile</a></li>
            <li><a [routerLink]="[{ outlets: { 'my-account-tab': ['change-password'] } }]" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }">Password</a></li>
            <ng-template [appAuthIf]="[CognitoGroup.RegistrantAdmin, CognitoGroup.Carrier]">
                <li><a [routerLink]="[{ outlets: { 'my-account-tab': ['user-management'] } }]" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }">User Management</a></li>
            </ng-template>
            <li *appAuthIf="(['Registrant'])"><a [routerLink]="[{ outlets: { 'my-account-tab': ['payment-method'] } }]" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }">Payment Method</a></li>
        </ul>
    </div>
</div>
<div class="tabcontent">
    <router-outlet name="my-account-tab"></router-outlet>
</div>
